<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
        <path d="M1.65967 4.97009H18.8536" stroke="#5F5F63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15.5481 20.9978H5.03631C4.554 20.9978 4.09145 20.8062 3.75041 20.4651C3.40937 20.1241 3.21777 19.6615 3.21777 19.1792V4.97009H17.3666V19.1792C17.3666 19.6615 17.175 20.1241 16.834 20.4651C16.4929 20.8062 16.0304 20.9978 15.5481 20.9978Z" stroke="#5F5F63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.86883 1H12.6091C13.0914 1 13.5539 1.19159 13.895 1.53264C14.236 1.87368 14.4276 2.33623 14.4276 2.81853V4.97012H6.05029V2.81853C6.05029 2.33623 6.24189 1.87368 6.58293 1.53264C6.92397 1.19159 7.38652 1 7.86883 1Z" stroke="#5F5F63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.44824 9.89795V15.9516" stroke="#5F5F63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.4189 9.89795V15.9516" stroke="#5F5F63" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: "IconTrash"
}
</script>

<style scoped>

</style>
